import React from "react";
import {
  Modal,
  Tabs,
  Form,
  Input,
  Button,
  Switch,
  Typography,
  Alert,
} from "antd";
import { THEME } from "../../styles/colors";

const { Text } = Typography;

const CONTACT_US_URL = "https://integratedadvisory.com.au/contact-us";

/**
 * Login / Register popup — same onLogin contract as legacy Signin form:
 * onLogin(event, email, password)
 */
function AuthModal({
  open,
  onClose,
  activeTab,
  onTabChange,
  onLogin,
  loginInvalid,
  loading,
}) {
  const [loginForm] = Form.useForm();

  const handleLoginFinish = (values) => {
    onLogin(
      { preventDefault: () => {} },
      values.username,
      values.password,
    );
  };

  const switchToRegister = () => onTabChange("register");
  const switchToLogin = () => onTabChange("login");

  const tabItems = [
    {
      key: "login",
      label: "Log in",
      children: (
        <>
          <Text type="secondary" className="auth-modal-subtitle">
            Enter your email and password to access ARC.
          </Text>
          {loginInvalid && (
            <Alert
              type="error"
              showIcon
              message="Incorrect email or password. Please try again."
              style={{ marginBottom: 16 }}
            />
          )}
          <Form
            form={loginForm}
            layout="vertical"
            onFinish={handleLoginFinish}
            className="auth-modal-form"
            requiredMark={false}
          >
            <Form.Item
              label="Email"
              name="username"
              rules={[{ required: true, message: "Please enter your email" }]}
            >
              <Input placeholder="Email address" autoComplete="username" />
            </Form.Item>
            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: "Please enter your password" }]}
            >
              <Input.Password
                placeholder="Password"
                autoComplete="current-password"
              />
            </Form.Item>
            <Form.Item name="remember" valuePropName="checked">
              <Switch size="small" defaultChecked />{" "}
              <span className="auth-modal-remember">Remember me</span>
            </Form.Item>
            <Form.Item style={{ marginBottom: 8 }}>
              <Button
                type="primary"
                htmlType="submit"
                block
                loading={loading}
                style={{
                  backgroundColor: THEME.primary,
                }}
              >
                Sign in
              </Button>
            </Form.Item>
          </Form>
          <p className="auth-modal-footer-link">
            Don&apos;t have an account?{" "}
            <button type="button" className="auth-modal-link" onClick={switchToRegister}>
              Register
            </button>
          </p>
        </>
      ),
    },
    {
      key: "register",
      label: "Register",
      children: (
        <div className="auth-modal-demo">
          <Text type="secondary" className="auth-modal-subtitle">
            ARC access is provisioned for enterprise teams on request.
          </Text>
          <p className="auth-modal-demo-text">
            To arrange a personalised demonstration and discuss onboarding for
            your organisation, please connect with our team.
          </p>
          <Button
            type="primary"
            block
            href={CONTACT_US_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ backgroundColor: THEME.primary }}
          >
            Contact us to request a demo
          </Button>
          <p className="auth-modal-footer-link">
            Already have an account?{" "}
            <button type="button" className="auth-modal-link" onClick={switchToLogin}>
              Log in
            </button>
          </p>
        </div>
      ),
    },
  ];

  return (
    <Modal
      title={activeTab === "login" ? "Welcome back" : "Request a demo"}
      open={open}
      onCancel={onClose}
      footer={null}
      width={440}
      destroyOnClose
      className="auth-modal"
      maskClosable={!loading}
      closable={!loading}
    >
      <Tabs
        activeKey={activeTab}
        onChange={onTabChange}
        items={tabItems}
        className="auth-modal-tabs"
      />
    </Modal>
  );
}

export default AuthModal;
